/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';
import isEqual from 'react-fast-compare';

import EntryActions from 'actions/EntryActions';
import NoteActions from 'actions/NoteActions';
import * as SelectionActions from 'actions/SelectionActions';
import * as analytics from 'analytics/Analytics';
import DataConnector from 'connect/DataConnector';
import {ELN_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FileStates from 'FileStates';
import NoteDAO from 'notebook/bioentities/NoteDAO';
import NoteStore from 'notebook/bioentities/NoteStore';
import EntryNoteUpdater from 'notebook/entries/EntryNoteUpdater';
import BioentityNoteUpdater from 'notebook/notes/BioentityNoteUpdater';
import {EditorPropertiesContext, NoteContext} from 'notebook/notes/core-ui/NoteContext';
import * as NoteStoreTransforms from 'notebook/notes/NoteStoreTransforms';
import {NoteView} from 'notebook/notes/tabs/NoteViews';
import ReviewConstants from 'notebook/reviews/ReviewConstants';
import * as ReviewUtil from 'notebook/reviews/ReviewUtil';
// @ts-expect-error
import HistoryManager from 'notebook/store/HistoryManager';
import isConfiguration from 'notebook/util/isConfiguration';
// @ts-expect-error
import EntryStore from 'stores/EntryStore';
import {ButtonStyle} from 'ui-library/buttons/Button';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import Modal from 'ui-library/modals/Modal';
import APIUtil from 'util/APIUtil';
import {typeToName} from 'util/NameUtil';

class QuickEditNoteViewConnector extends DataConnector<
  BaseQuickEditNoteViewProps,
  QuickEditNoteViewEnhancedProps
> {
  shouldSubscribeToRedux = false;
  stores = [EntryStore, NoteStore];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getReviewStatus() {
    if (this.entryStore().inStore(this.props.fileId)) {
      const {entry} = this.entryStore().getEditorState(this.props.fileId);
      return __guard__(
        __guard__(entry, (x1: any) => x1.review),
        (x: any) => x.status
      );
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getNote() {
    let note;
    if (this.noteStore().inStore(this.props.fileId)) {
      ({note} = this.noteStore().getEditorState(this.props.fileId));
      return note;
    } else if (this.entryStore().inStore(this.props.fileId)) {
      const {entry} = this.entryStore().getEditorState(this.props.fileId);
      return __guard__(entry, (x: any) => x.note);
    }
    return null;
  }

  enhanceProps(): QuickEditNoteViewEnhancedProps {
    return {
      noteFromStore: this.getNote(),
      reviewStatusFromStore: this.getReviewStatus(),
    };
  }
}

interface BaseQuickEditNoteViewProps {
  fileId: string;
}
interface QuickEditNoteViewEnhancedProps {
  noteFromStore: any;
  reviewStatusFromStore: any;
}

type QuickEditNoteViewProps = BaseQuickEditNoteViewProps & QuickEditNoteViewEnhancedProps;

type QuickEditNoteViewState = any;

class QuickEditNoteView extends React.Component<QuickEditNoteViewProps, QuickEditNoteViewState> {
  _isMounted: any;
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _getUpdater = () => {
    const ANoteUpdater = APIUtil.isEntry(this.props.fileId) ? EntryNoteUpdater : BioentityNoteUpdater;
    return new ANoteUpdater(
      this.props.fileId,
      () => this.state.note,
      (note: any) => {
        if (this._isMounted) {
          this.updateNote(note);
        }
      }
    );
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _transformNoteFromStoreForState = () =>
    this.props.noteFromStore ? this._getUpdater().run(this.props.noteFromStore, null) : null;

  componentDidMount(): void {
    this._isMounted = true;
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps: QuickEditNoteViewProps): void {
    if (
      this.state.note == null &&
      (!isEqual(this.props.noteFromStore, prevProps.noteFromStore) ||
        !isEqual(this.props.reviewStatusFromStore, prevProps.reviewStatusFromStore))
    ) {
      this.setState({
        // TODO(BNCH-14590): Any pending edits will get blown away from async resolutions from store.
        note: this._transformNoteFromStoreForState(),
        reviewStatus: this.props.reviewStatusFromStore,
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getIdFromCid = (cid: any) => {
    const store = this.isEntry() ? EntryStore : NoteStore;
    return store.getIdFromCid(this.props.fileId, cid);
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getTypeName = () => typeToName(APIUtil.apiIdToType(this.props.fileId));

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateNote = (note: any) => {
    const oldNote = this.state.note;
    const sanitizedNote = NoteStoreTransforms.sanitizeNote(note, oldNote);
    const updatedNote = this._getUpdater().run(sanitizedNote, oldNote);
    this.setState({note: updatedNote});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  restoreStateAndSelection = ({note}: any, restoreData: any) => {
    SelectionActions.setSelection(restoreData);
    this.setState({note});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  saveEntry = () => {
    if (this.isLocked()) {
      return;
    }
    const {note} = this.state;
    if (note != null) {
      EntryActions.updateNote(this.props.fileId, note);
      EntryActions.save(this.props.fileId);
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  saveNote = () => {
    if (this.isLocked()) {
      return;
    }
    const {note} = this.state;
    if (note != null) {
      NoteActions.update(this.props.fileId, {$set: note});
      NoteActions.save(this.props.fileId);
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isEntry = () => APIUtil.apiIdToType(this.props.fileId) === ModelTypeConstants.ENTRY;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isLocked = () =>
    this.isEntry() && Array.from(ReviewConstants.LOCKED_STATUSES).includes(this.state.reviewStatus);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  registerObjects = (cidIdMap: any) => {
    const actions = this.isEntry() ? EntryActions : NoteActions;
    actions.registerObjects(this.props.fileId, cidIdMap);
  };

  state: QuickEditNoteViewState = {
    note: this._transformNoteFromStoreForState(),
    historyManager: new HistoryManager(),
    reviewStatus: this.props.reviewStatusFromStore,
  };

  render(): JSX.Element {
    if (this.state.note == null) {
      return <CenteredHorizontalThrobber />;
    }
    return (
      <div>
        {this.isLocked() && (
          <p className="text-warning">{ReviewUtil.getEditWarning(this.state.reviewStatus)}</p>
        )}
        <EditorPropertiesContext.Provider
          // eslint-disable-next-line react/jsx-no-constructed-context-values -- can be fixed with useMemo if we make this a function component
          value={{
            showFormulas: false,
            fileId: this.props.fileId,
            isConfig: isConfiguration(this.props.fileId),
          }}
        >
          {/* eslint-disable-next-line react/jsx-no-constructed-context-values -- can be fixed with useMemo if we make this a function component */}
          <NoteContext.Provider value={{note: this.state.note ?? undefined}}>
            <NoteView
              fileId={this.props.fileId}
              fileType={APIUtil.apiIdToType(this.props.fileId)}
              note={this.state.note}
              updateNote={this.updateNote}
              restoreStateAndSelection={this.restoreStateAndSelection}
              historyManager={this.state.historyManager}
              preview={{
                showOpenLink: true,
                followLink: true,
              }}
              disableFormatting={false}
              disableMaximizedTables={true}
              parentType={this.isEntry() ? 'Entry' : 'Note'}
              locked={this.isLocked()}
              banner={this.isLocked() ? `Editing disabled on locked ${this.getTypeName()}` : null}
              printOptions={[]}
              showTableOfContents={false}
              showTimestamps={false}
              registerObjects={this.registerObjects}
              getIdFromCid={this.getIdFromCid}
              spellCheck={false}
              printLayout={true}
              showPrintMargins={false}
            />
          </NoteContext.Provider>
        </EditorPropertiesContext.Provider>
      </div>
    );
  }
}

const ConnectedQuickEditNoteView = QuickEditNoteViewConnector.connect(QuickEditNoteView);

interface QuickEditModalProps {
  fileId: string;
  initialName: React.ReactNode;
  parentFolderId?: any;
  isRegisteredItem: boolean;
  onRequestClose: (...args: Array<any>) => any;
}

type QuickEditModalState = any;

class QuickEditModal extends React.Component<QuickEditModalProps, QuickEditModalState> {
  noteViewRef: any;
  noteXhr: any;
  state: QuickEditModalState = {
    name: this.props.initialName,
  };

  componentDidMount(): void {
    if (this.isEntry()) {
      if (!EntryStore.inStore(this.props.fileId)) {
        EntryActions.open(this.props.fileId);
      }
    } else if (!NoteStore.inStore(this.props.fileId)) {
      this.noteXhr = NoteDAO.get(this.props.fileId).done((note: any) => {
        NoteActions.load(this.props.fileId, note);
      });
    }

    analytics.deprecatedTrackEvent(ELN_ANALYTICS_ACTIONS.OPENED_QUICK_EDIT_MODAL, {
      modelType: APIUtil.apiIdToType(this.props.fileId),
    });
  }

  componentWillUnmount(): void {
    // TODO(T1847): remove after adding refcounts
    if (FileStates.get().get(this.props.fileId) == null) {
      if (this.isEntry()) {
        EntryActions.close(this.props.fileId);
      } else {
        __guard__(this.noteXhr, (x: any) => x.abort());
        // If the user closes the quick edit modal before the note is fetched, it's not present in the store.
        // EntryActions inserts the entry into the store before the fetch is sent, so we don't need
        // this check.
        if (NoteStore.inStore(this.props.fileId)) {
          NoteActions.close(this.props.fileId);
        }
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setNoteViewRef = (element: any) => {
    this.noteViewRef = element;
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isEntry = () => APIUtil.apiIdToType(this.props.fileId) === ModelTypeConstants.ENTRY;

  saveAndClose = async (): Promise<void> => {
    const oldName = this.props.initialName;
    const newName = this.state.name;

    if (oldName !== newName) {
      await FileBrowserActions.renameFileWithDataMods(this.props.fileId, this.props.isRegisteredItem, {
        oldName: oldName as string,
        newName: newName as string,
        parentFolderId: this.props.parentFolderId,
        notifyOnSuccess: false,
      });
    }

    if (this.isEntry()) {
      this.noteViewRef.saveEntry();
    } else {
      this.noteViewRef.saveNote();
    }
    this.props.onRequestClose();

    analytics.deprecatedTrackEvent(ELN_ANALYTICS_ACTIONS.SAVED_QUICK_EDIT_MODAL, {
      modelType: APIUtil.apiIdToType(this.props.fileId),
    });
  };

  render(): JSX.Element {
    return (
      <Modal
        className="modal--mediocre"
        fullWidth={true}
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.saveAndClose}
        title={`Edit ${this.isEntry() ? 'notes' : 'description'}`}
        wrapInForm={false}
        buttons={[
          {
            text: 'Save',
            submit: true,
            style: ButtonStyle.PRIMARY,
          },
        ]}
      >
        <div className="u-flex-display u-flex-grow u-vertical-flex">
          <div className="quickEditModal-name u-flex-none u-flex-display">
            <label className="u-flex-none u-no-spacing-bottom u-input-line-height u-small-spacing-right">
              Name
            </label>
            <div className="u-flex-grow">
              <input
                type="text"
                value={this.state.name}
                onChange={(e) => {
                  this.setState({name: e.target.value});
                }}
              />
            </div>
          </div>
          <div className="u-flex-grow u-position-relative">
            <ConnectedQuickEditNoteView fileId={this.props.fileId} setRef={this.setNoteViewRef} />
          </div>
        </div>
      </Modal>
    );
  }
}

export default QuickEditModal;

function __guard__(value: any, transform: any): any {
  return value != null ? transform(value) : undefined;
}
